/**
 * Bug-report API client. The in-app 🐞 reporter POSTs a description + captured context
 * (page/request/console history) + an optional screenshot data URL; the backend stores the
 * screenshot and emails the owner.
 */
import { useMutation } from "@tanstack/react-query";
import { api } from "./client";

export interface BugReportPayload {
  page: string;
  description: string;
  browser_info: string;
  state_snapshot: Record<string, unknown>;
  screenshot?: string | null;
}

/** POST /api/bug-reports — file a bug report. */
export function useSubmitBugReport() {
  return useMutation({
    mutationFn: async (payload: BugReportPayload): Promise<{ id: string }> => {
      const { data } = await api.post<{ id: string }>("/bug-reports", payload);
      return data;
    },
  });
}
